export function clearAuthStorage() {
  localStorage.removeItem('authenticatedAt');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenUser');
  localStorage.removeItem('user');
  localStorage.removeItem('isLoggedIn');
}

export function isExpiredSessionError(error) {
  const status = error && error.response ? error.response.status : null;
  const message = error && error.response && error.response.data
    ? error.response.data.message
    : '';

  if (status !== 401) {
    return false;
  }

  return message === 'User session is missing or expired.'
    || message === 'Not authenticated.';
}
